import TitleBlock from './TitleBlock'
import ButtonEl from './ctas/Button'
import { hasRenderableText } from '../../helpers/markup'

/**
 * Default stacked header layout used by all section types except cardListCurated.
 * Renders the title/description above the section content, with optional CTA
 * buttons below for subPageBanner and accordion types.
 */
const SectionLayoutDefault = ({ sectionProps, titleBlockDescClass }) => {
  const showCtaButtons =
    (sectionProps.type === 'subPageBanner' && sectionProps.variant !== 'Split content and image') ||
    (sectionProps.type === 'accordion' && sectionProps.ctaLinkItem && sectionProps.ctaLinkItem.length !== 0)

  const isSearch = sectionProps.type === 'searchResult'

  return (
    <>
      {sectionProps.sectionTitle !== false &&
        (hasRenderableText(sectionProps.title) || hasRenderableText(sectionProps.description)) && (
        isSearch ? (
          <>
            <div className="[&_[data-type='section-title']_span]:max-lg:!text-3xl">
              <TitleBlock {...sectionProps} descriptionClass={`${titleBlockDescClass} mt-4! lg:mt-10!`} />
            </div>
            <hr className="border-0 border-b border-gray-300 max-md:-mx-5 md:max-lg:-mx-8 mt-8" />
          </>
        ) : (
          <TitleBlock {...sectionProps} descriptionClass={titleBlockDescClass} />
        )
      )}

      {showCtaButtons && (
        <div
          data-type="cta-links"
          className={`flex flex-col md:flex-row gap-4 md:gap-8 ${sectionProps.ctaLinkAlignment === 'Center' ? 'justify-center' : 'justify-start'}`}
        >
          {sectionProps.ctaLinkItem.map((ctaLinkItem, i) => (
            <ButtonEl
              key={i}
              link={ctaLinkItem.link}
              icon={ctaLinkItem.linkIconClass}
              position={ctaLinkItem.linkPosition}
              theme={ctaLinkItem.linkType.toLowerCase()}
              className={`${!sectionProps.backgroundColor && ctaLinkItem.linkType.toLowerCase() === 'text' ? 'text-(--color-secondary)' : ''}`}
            />
          ))}
        </div>
      )}
    </>
  )
}

export default SectionLayoutDefault
